import React from 'react';
import PropTypes from 'prop-types';

// Components
import { Heading, Status, Button } from 'components';

// Style
import classNames from 'classnames/bind';
import styles from '../styles.pcss';
const cx = classNames.bind(styles);

const NotAllowedStep = ({
  onClose,
  data: {
    title,
    params,
    statusText,
    buttonConfirmText,
    buttonCancelText,
    paymentUrl,
  },
}) => (
  <div>
    <Heading level={1} isStyled={false}>
      <span dangerouslySetInnerHTML={{ __html: title }} />
    </Heading>

    <div className={cx('content')}>
      <div className={cx('status')}>
        <Status className={['error']}>
          <p dangerouslySetInnerHTML={{ __html: statusText }} />
        </Status>
      </div>

      {params && (
        <div className={cx('paramsGroup')}>
          {params.map((item, key) => (
            <div key={key} className={cx('params')}>
              <div className={cx('description')}>{item.description}</div>
              <div className={cx('value')}>{item.value}</div>
            </div>
          ))}
        </div>
      )}

      <div className={cx('buttonsGroup')}>
        <Button
          onClick={onClose}
          className={cx('big')}
          color="light"
          wide
        >
          {buttonCancelText}
        </Button>
        <Button
          className={cx('big')}
          href={paymentUrl}
          wide
        >
          {buttonConfirmText}
        </Button>
      </div>
    </div>
  </div>
);

NotAllowedStep.propTypes = {
  onClose: PropTypes.func,
  data: PropTypes.shape({
    params: PropTypes.array,
    title: PropTypes.string,
    statusText: PropTypes.string,
    buttonCancelText: PropTypes.string,
    buttonConfirmText: PropTypes.string,
    paymentUrl: PropTypes.string,
  }),
};

export default NotAllowedStep;
